// ----------------------------------------------------------------------------
// Event Names
// ----------------------------------------------------------------------------

export const AMPLITUDE_EVENT_ENTRY_DELETED = 'Entry Deleted'
export const AMPLITUDE_EVENT_ENTRIES_DELETED = 'Entries Deleted'
export const AMPLITUDE_EVENT_ENTRY_DETAILS_OPENED = 'Entry Details Opened'
export const AMPLITUDE_EVENT_ENTRY_DETAILS_NEXT_PREV_CLICKED = 'Entry Details Next/Prev Clicked'
export const AMPLITUDE_EVENT_ENTRY_PRINTED = 'Entry Printed'
export const AMPLITUDE_EVENT_ENTRY_MANAGER_OPENED = 'Entry Manager Opened'
export const AMPLITUDE_EVENT_ENTRY_MANAGER_FILTER_APPLIED = 'Entry Manager Filter Applied'
export const AMPLITUDE_EVENT_ENTRY_MANAGER_FILTER_CREATED = 'Entry Manager Filter Created'
export const AMPLITUDE_EVENT_ENTRY_MANAGER_COLUMNS_MODIFIED = 'Entry Manager Columns Modified'
export const AMPLITUDE_EVENT_FORM_MANAGER_LAUNCHED = 'Form Manager Launched'
export const AMPLITUDE_EVENT_FORM_MANAGER_ACTION_PERFORMED = 'Form Manager Action Performed'
export const AMPLITUDE_EVENT_FORM_MANAGER_BULK_ACTION_CLICKED_IN_DRAWER = 'Form Manager Bulk Action Clicked in Drawer'
export const AMPLITUDE_EVENT_FORM_MANAGER_DUPLICATE_FORM = 'Form Manager Duplicate Form'
export const AMPLITUDE_EVENT_FORM_MANAGER_FORM_RENAME = 'Form Manager Form Rename'
export const AMPLITUDE_EVENT_FORM_MANAGER_VIEW_FORM = 'Form Manager View Form'
export const AMPLITUDE_EVENT_FORM_MANAGER_SEARCH = 'Form Manager Search'
export const AMPLITUDE_EVENT_FORM_MANAGER_FILTER_BY_LABELS = 'Form Manager Filter by Labels'
export const AMPLITUDE_EVENT_FORM_MANAGER_SORT = 'Form Manager Sort'
export const AMPLITUDE_EVENT_FORM_MANAGER_PAGE_TURNED = 'Form Manager Page Turned'
export const AMPLITUDE_EVENT_FORM_BUILDER_LAUNCHED = 'Form Builder Launched'
export const AMPLITUDE_EVENT_UPGRADE_CTA_CLICKED = 'Upgrade CTA Clicked'
export const AMPLITUDE_EVENT_FORM_SHARED = 'Form Shared'

// ----------------------------------------------------------------------------
// Event Properties
// ----------------------------------------------------------------------------

// Form Properties
export const AMPLITUDE_EVENT_PROPERTY_FORM_TYPE = 'Form Type'
export const AMPLITUDE_EVENT_PROPERTY_FORM_TYPE_VIEW = 'Form Type View'
export const AMPLITUDE_EVENT_PROPERTY_FORM_ID = 'Form ID'
export const AMPLITUDE_EVENT_PROPERTY_SOURCE_FORM_ID = 'Source Form ID'
export const AMPLITUDE_EVENT_PROPERTY_PASSWORD_REQUIRED = 'Password Required?'
export const AMPLITUDE_EVENT_PROPERTY_CREATE_FORM = 'Create Form'

// Form Manager Properties
export const AMPLITUDE_EVENT_PROPERTY_NUM_FORMS_SELECTED = '# of Forms Selected'
export const AMPLITUDE_EVENT_PROPERTY_ALL_FORMS_SELECTED = 'All Forms Selected?'
export const AMPLITUDE_EVENT_PROPERTY_TOTAL_NUM_FORMS = 'Total # of Forms'
export const AMPLITUDE_EVENT_PROPERTY_FORMS_PER_PAGE = 'Forms Per Page'
export const AMPLITUDE_EVENT_PROPERTY_NUM_FORMS_RETURNED = '# of Forms Returned'
export const AMPLITUDE_EVENT_PROPERTY_TOTAL_NUM_FORMS_IN_ACCOUNT = 'Total # of Forms in Account'

// Entry Properties
export const AMPLITUDE_EVENT_PROPERTY_ENTRY_ID = 'Entry ID'
export const AMPLITUDE_EVENT_PROPERTY_ENTRY_CREATED_DATE = 'Entry Created Date'
export const AMPLITUDE_EVENT_PROPERTY_ENTRY_MANAGER_VERSION = 'Entry Manager Version'
export const AMPLITUDE_EVENT_PROPERTY_NUM_ENTRIES = '# of Entries'
export const AMPLITUDE_EVENT_PROPERTY_NUM_ENTRIES_DELETED = '# of Entries Deleted'
export const AMPLITUDE_EVENT_PROPERTY_NUM_ENTRIES_RETURNED = '# of Entries Returned'
export const AMPLITUDE_EVENT_PROPERTY_ALL_ENTRIES_SELECTED = 'All Entries Selected'
export const AMPLITUDE_EVENT_PROPERTY_ENTRIES_PER_PAGE = 'Entries per page'
export const AMPLITUDE_EVENT_PROPERTY_NUM_QUESTIONS = '# of Questions'

// Filter & Search Properties
export const AMPLITUDE_EVENT_PROPERTY_FILTER_APPLIED = 'Filter Applied'
export const AMPLITUDE_EVENT_PROPERTY_FILTER_PRE_APPLIED = 'Filter Pre-applied?'
export const AMPLITUDE_EVENT_PROPERTY_FILTERED_BY_METADATA = 'Filtered by Metadata'
export const AMPLITUDE_EVENT_PROPERTY_IS_FILTERED_BY_FORM_FIELDS = 'Is Filtered by Form Fields'
export const AMPLITUDE_EVENT_PROPERTY_PRE_BUILT_FILTER_USED = 'Pre-built Filter Used'
export const AMPLITUDE_EVENT_PROPERTY_NUM_ARGUMENTS = '# of Arguments'
export const AMPLITUDE_EVENT_PROPERTY_SEARCH_TYPE = 'Search Type'
export const AMPLITUDE_EVENT_PROPERTY_SEARCH_PRE_APPLIED = 'Search Pre-applied?'
export const AMPLITUDE_EVENT_PROPERTY_SEARCH_APPLIED = 'Search Applied?'
export const AMPLITUDE_EVENT_PROPERTY_HAS_FILTER = 'Has Filter?'

// Sort Properties
export const AMPLITUDE_EVENT_PROPERTY_SORT_BY = 'Sort By'
export const AMPLITUDE_EVENT_PROPERTY_SORT_ORDER = 'Sort Order'
export const AMPLITUDE_EVENT_PROPERTY_SORT_BY_PROP = 'Sort by'
export const AMPLITUDE_EVENT_PROPERTY_SORT_ORDER_PROP = 'Sort order'
export const AMPLITUDE_EVENT_PROPERTY_OLD_SORT_BY = 'Old Sort By'
export const AMPLITUDE_EVENT_PROPERTY_NEW_SORT_BY = 'New Sort By'
export const AMPLITUDE_EVENT_PROPERTY_OLD_SORT_ORDER = 'Old Sort Order'
export const AMPLITUDE_EVENT_PROPERTY_NEW_SORT_ORDER = 'New Sort Order'

// Label Properties
export const AMPLITUDE_EVENT_PROPERTY_NUM_LABELS_APPLIED = '# of Labels Applied'
export const AMPLITUDE_EVENT_PROPERTY_VISIBILITY = 'Visibility'

// Column Properties
export const AMPLITUDE_EVENT_PROPERTY_NUM_COLUMNS_SELECTED = '# of columns selected'

// Navigation Properties
export const AMPLITUDE_EVENT_PROPERTY_DIRECTION = 'Direction'
export const AMPLITUDE_EVENT_PROPERTY_PAGE_TURNED_TYPE = 'Page Turned Type'
export const AMPLITUDE_EVENT_PROPERTY_NUM_PAGES = '# of Pages'

// Action Properties
export const AMPLITUDE_EVENT_PROPERTY_ACTION_PERFORMED = 'Action Performed'
export const AMPLITUDE_EVENT_PROPERTY_ACTION_INVOKED_LOCATION = 'Action Invoked Location'
export const AMPLITUDE_EVENT_PROPERTY_PURPOSE = 'Purpose'
export const AMPLITUDE_EVENT_PROPERTY_ON_LOGIN = 'On Login?'

// CTA Properties
export const AMPLITUDE_EVENT_PROPERTY_CTA_NAME = 'CTA Name'

// Share Properties
export const AMPLITUDE_EVENT_PROPERTY_CHANNEL = 'Channel'

// ----------------------------------------------------------------------------
// User Properties (Super Properties)
// ----------------------------------------------------------------------------
// Shared between frontend and backend - keep names in sync!

export const SUPER_PROPERTY_PROFILE_ID = 'Profile ID'
export const SUPER_PROPERTY_USER_ID = 'User ID'
export const SUPER_PROPERTY_PLAN_TYPE = 'Plan Type'
export const SUPER_PROPERTY_PLAN_ID = 'Plan ID'
export const SUPER_PROPERTY_BILLING_FREQUENCY = 'Billing Frequency'

// User Properties - Forms
export const USER_PROPERTY_NUM_NEW_FORMS = '# of New Forms'
export const USER_PROPERTY_NUM_FORMS = '# of Forms'
